<template>
  <div class="wg-row">
    <!-- Modale per la cancellazione stanza associata -->
    <wg-modal
      simple
      v-if="deleteRoomDialog"
      @closeModal="deleteRoomDialog = false"
    >
      <div class="wg-row" style="justify-content: center" slot="body">
        <div class="com-anm22-app-text-xl">
          {{
            $anm22.strLang(lang, "Delete room?", "Cancellare stanza associata?")
          }}
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div
          class="wg-row"
          style="align-items: center; justify-content: center"
        >
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="deleteRoomRef"
          />
          <div class="com-anm22-app-horizontal-space" style="width: 20px"></div>
          <input
            type="button"
            class="small"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="deleteRoomDialog = false"
          />
        </div>
      </div>
    </wg-modal>
    <wg-modal simple v-if="deleteDialog" @closeModal="deleteDialog = false">
      <div class="wg-row" style="justify-content: center" slot="body">
        <div class="com-anm22-app-text-xl">
          {{
            $anm22.strLang(
              lang,
              "Delete project link?",
              "Cancellare progetto associato?"
            )
          }}
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div
          class="wg-row"
          style="align-items: center; justify-content: center"
        >
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="deleteProjectRef"
          />
          <div class="com-anm22-app-horizontal-space" style="width: 20px"></div>
          <input
            type="button"
            class="small"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="deleteDialog = false"
          />
        </div>
      </div>
    </wg-modal>
    <wg-modal
      v-if="openLinkModal"
      :width="windowWidth > 700 ? '700px' : '90%'"
      @closeModal="openLinkModal = false"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "Add new link", "Aggiungi link") }}
        </div>
      </div>
      <world-add-link
        :element="event"
        @save="saveLink"
        slot="body"
      ></world-add-link>
    </wg-modal>
    <!-- Gestione messaggi di errore -->
    <div v-if="errors.length" class="wg-row">
      <b>{{
        $anm22.strLang(lang, "Alert Messagge", "Messaggio Informativo")
      }}</b>
      <ul>
        <li v-for="(error, index) in errors" :key="'error' + index">
          {{ error }}
        </li>
      </ul>
    </div>
    <!-- Select tipo di evento in caso di nuovo evento -->
    <div v-if="!event.idWorldEvent" class="wg-row" style="padding: 10px 20px">
      <div
        v-for="(type, i) in types"
        :key="'type-' + i"
        :class="['type-select-elem', type.id === event.type ? 'selected' : '']"
        @click="() => (event.type = type.id)"
      >
        {{ type.label }}
      </div>
    </div>
    <!-- Componente di render in base al tipo -->
    <div class="wg-row">
      <div class="anm22-calendar-wrapper-calendar">
        <component
          :is="getEventComponent()"
          @setErrors="setErrors"
          @showLinkModal="showLinkModal"
          :showSaved="showSaved"
          :eventRef="event"
          @save="save"
        ></component>
      </div>
    </div>
    <!-- Event cover -->
    <template v-if="event.type == 7">
      <event-cover
        :event="event"
        @updateEventDataProperty="updateEventDataProperty"
        :editMode="canEdit"
      ></event-cover>
    </template>
    <!-- Motorsport plugin -->
    <template v-if="event.type == 7">
      <event-motorsport
        :event="event"
        @updateEventProperty="updateEventProperty"
        @updateEventDataProperty="updateEventDataProperty"
        :editMode="canEdit"
      ></event-motorsport>
    </template>
    <!-- Gestione file evento -->
    <!-- ELENCO FILE EVENTO + MODIFICA -->
    <div v-if="event.type == 7" class="wg-row">
      <div class="anm22-calendar-wrapper-calendar">
        <event-file-uploader
          @setErrors="setErrors"
          @showLinkModal="showLinkModal"
          :showSaved="showSaved"
          :eventRef="event"
          @save="save"
        ></event-file-uploader>
      </div>
    </div>
    <!-- Gestione riferimento a progetto -->
    <!-- LINK AL PROGETTO TASKS SE PRESENTE + MODIFICA ASSOCIAZIONE -->
    <div v-if="event.type != 5 && event.type != 6" class="wg-row">
      <!-- Non visibile per promemoria e ferie -->
      <div class="anm22-calendar-wrapper-calendar">
        <template v-if="!editingProject">
          <div class="wg-row" style="flex-wrap: nowrap; align-items: center">
            <a
              v-if="event.projectRef"
              :href="'https://tasks.anm22.it/project/' + event.projectRef"
              class="wg-row project-link"
              :style="{ borderLeft: '3px solid ' + projectBorderColor }"
            >
              <img
                :src="$anm22.icons.getWorldIcon('menuTasks')"
                class="com-anm22-app-img-fixed-height-m"
                style="margin-right: 10px"
              />
              <div class="com-anm22-app-text-xl">{{ event.projectName }}</div>
            </a>
            <div v-else class="wg-row com-anm22-app-text-xl">
              {{
                $anm22.strLang(
                  lang,
                  "No project linked",
                  "Nessun progetto associato"
                )
              }}
            </div>
            <template v-if="canEditProjectLink">
              <img
                :src="$anm22.icons.getWorldIcon('edit')"
                class="com-anm22-app-img-fixed-height-m"
                style="margin-left: auto; cursor: pointer"
                @click="editProjectRef"
              />
              <template v-if="event.projectRef">
                <div class="com-horizontal-space" style="width: 10px"></div>
                <img
                  class="com-anm22-app-img-fixed-height-m"
                  style="margin-left: auto; cursor: pointer"
                  :src="$anm22.icons.getWorldIcon('deleteBin')"
                  @click="deleteDialog = true"
                />
              </template>
            </template>
          </div>
        </template>
        <!-- Barra di ricerca per la modifica dell'associazione -->
        <template v-else>
          <div
            class="wg-row"
            style="
              align-items: center;
              flex-wrap: nowrap;
              justify-content: space-between;
            "
          >
            <div class="wg-col wg-xs-10 wg-md-8">
              <wg-search
                :mode="'offline'"
                :placeholder="$anm22.strLang(lang, 'Project...', 'Progetto...')"
                :searchFn="searchProject"
                :clickFn="setProjectLink"
                :debounceTime="1000"
              ></wg-search>
            </div>
            <!-- <select class="com-anm22-app-select" v-model="projectSelect">
              <option
                v-for="(p,index) in projectOptions"
                :key="'proj-'+index"
                :value="p.id"
              >{{ p.label }}</option>
            </select> -->
            <div class="display-flex" style="justify-content: space-between">
              <!-- <div
                v-if="projectOptions.length"
                class="display-flex icon-button"
                @click="setProjectLink"
              >
                <img
                  class="com-anm22-app-img-fixed-height-m"
                  :src="$anm22.icons.getWorldIcon('tick')"
                />
              </div> -->
              <div class="display-flex icon-button" @click="stopEditProjectRef">
                <img
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                />
              </div>
              <!-- <div
                v-if="event.projectRef && canEditProjectLink"
                class="display-flex icon-button"
                @click="deleteProjectRef"
              >
                <img
                  class="com-anm22-app-img-fixed-height-m"
                  :src="$anm22.icons.getWorldIcon('deleteBin')"
                />
              </div> -->
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- Gestione riferimento stanza -->
    <!-- NOME STANZA SE PRESENTE + MODIFICA ASSOCIAZIONE -->
    <div
      class="wg-row"
      v-if="
        event.type != 4 && event.type != 5 && event.type != 6 && event.type != 8
      "
    >
      <!-- Non visibile per consegna Vircos, promemoria e ferie -->
      <div class="anm22-calendar-wrapper-calendar">
        <template v-if="!editingResource">
          <div class="wg-row" style="flex-wrap: nowrap; align-items: center">
            <div
              v-if="event.room && room"
              class="wg-row"
              style="align-items: center; padding: 5px 5px 5px 10px"
            >
              <img
                v-if="room && room.icon"
                class="com-anm22-app-img-fixed-height-m"
                style="margin-right: 10px"
                :src="$anm22.icons.getWorldIcon(room.icon)"
              />
              <div class="com-anm22-app-text-xl">{{ room.name }}</div>
            </div>
            <div v-else class="wg-row com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, "No room", "Nessuna stanza") }}
            </div>
            <template v-if="event.idWorldEvent">
              <img
                :src="$anm22.icons.getWorldIcon('edit')"
                class="com-anm22-app-img-fixed-height-m"
                style="margin-left: auto; cursor: pointer"
                @click="editRoom"
              />
              <template v-if="event.room">
                <div class="com-horizontal-space" style="width: 10px"></div>
                <img
                  class="com-anm22-app-img-fixed-height-m"
                  style="margin-left: auto; cursor: pointer"
                  :src="$anm22.icons.getWorldIcon('deleteBin')"
                  @click="deleteRoomDialog = true"
                />
              </template>
            </template>
          </div>
        </template>
        <!-- Barra di ricerca per la modifica dell'associazione -->
        <template v-else>
          <div
            class="wg-row"
            style="
              align-items: center;
              flex-wrap: nowrap;
              justify-content: space-between;
            "
          >
            <div class="wg-col wg-xs-10 wg-md-8">
              <wg-search
                :mode="'offline'"
                :placeholder="$anm22.strLang(lang, 'Room...', 'Stanza...')"
                :searchFn="searchResources"
                :clickFn="setRoom"
                :debounceTime="1000"
              ></wg-search>
            </div>
            <div class="display-flex" style="justify-content: space-between">
              <div
                class="display-flex icon-button"
                @click="stopEditResourceRef"
              >
                <img
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 15px"></div>
    <!-- GESTIONE LINK -->
    <template
      v-if="
        event.idWorldEvent &&
        event.type !== 4 &&
        event.type !== 8 &&
        event.links.length > 0
      "
    >
      <div class="widgets-box com-anm22-app-custom-scroll">
        <world-links
          :isModal="true"
          :links="event.links"
          @removeLink="deleteEventLink"
        ></world-links>
        <div
          class="display-flex link-buttons"
          style="align-items: center; flex-wrap: nowrap"
        >
          <div class="wg-row icons">
            <div class="icon-div">
              <img
                class="com-anm22-app-img-fixed-height-l"
                style="padding: 5px; height: 100%"
                :title="$anm22.strLang(lang, 'Add link', 'Aggiungi link')"
                :src="$anm22.icons.getWorldIcon('link')"
                @click="openLinkModal = true"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Gestione invitati -->
    <div
      class="wg-row"
      v-if="
        event.idWorldEvent &&
        event.type !== 4 &&
        event.type !== 6 &&
        event.type !== 8
      "
    >
      <div class="anm22-calendar-wrapper-calendar" style="padding-top: 0">
        <div class="invitation-title">
          <img :src="$anm22.icons.getWorldIcon('person')" class="label-ic" />
          <div>
            {{ $anm22.strLang(lang, "Invited", "Invitati") }}
          </div>
        </div>
        <div
          v-for="(obj, index) in invitesWithUser.filter(
            (invite) => invite.user
          )"
          :key="'invite-' + index"
          class="wg-row invitation-container"
        >
          <img :src="$anm22.getObjIcon(obj.user, 'userDefault')" />
          <div class="wg-row invitation-data">
            <div class="com-anm22-app-text-l">
              {{ obj.user.name + " " + obj.user.surname }}
              <span style="color: #aaa">
                {{
                  $anm22.tableClasses
                    .eventPermission()
                    .getById(obj.invite.permission)[lang] +
                  " - " +
                  $anm22.tableClasses.inviteStatus().getById(obj.invite.status)[
                    lang
                  ]
                }}
              </span>
            </div>
            <!-- Aggiunta amministratori -->
            <div
              v-if="
                typeof myInvite !== 'undefined' &&
                myInvite.permission == 1 &&
                obj.invite.user !== user.idWorldUser
              "
            >
              <img
                v-if="obj.invite.permission == 0"
                @click="adminInvite(obj.invite.idWorldEventInvite)"
                style="cursor: pointer"
                title="Nomina Admin"
                :src="$anm22.icons.getWorldIcon('userAdminAdd')"
                class="anm22-calendar-icon-inline"
              />
              <img
                v-else
                @click="delAdminInvite(obj.invite.idWorldEventInvite)"
                style="cursor: pointer"
                title="Remove Admin"
                :src="$anm22.icons.getWorldIcon('userAdminRemove')"
                class="anm22-calendar-icon-inline"
              />
              <img
                @click="delInvite(obj.invite.idWorldEventInvite)"
                style="cursor: pointer"
                title="Rimuovi invitato"
                :src="$anm22.icons.getWorldIcon('deleteBin')"
                class="anm22-calendar-icon-inline"
              />
            </div>
          </div>
          <div
            v-if="obj.user.idWorldUser === user.idWorldUser"
            class="wg-row invitation-response-container"
          >
            <div
              v-for="(s, i) in getStatusOptions(obj.invite)"
              :key="'status-btn-' + i"
              :class="[
                'anm22-calendar-invite-status',
                s.typeClass == obj.invite.status ? 'selected' : null,
              ]"
              @click="eventStatus(obj.invite.idWorldEventInvite, s.typeClass)"
            >
              <img
                :src="$anm22.icons.getWorldIcon(getStatusIcon(s.typeClass))"
                class="anm22-calendar-icon-inline"
              />
              <div class="anm22-calendar-field-inline">{{ s[lang] }}</div>
            </div>
          </div>
        </div>
        <!-- Aggiunta di nuovi inviti -->
        <div
          v-if="typeof myInvite !== 'undefined' && myInvite.permission == 1"
          class="wg-row new-invitation-container"
          style="margin-top: 20px"
        >
          <img class="invite-add-ic" :src="$anm22.icons.getWorldIcon('add')" />
          <div class="new-invitation-data">
            <wg-search
              v-if="!manualInvite"
              :placeholder="$anm22.strLang(lang, 'Invite', 'Aggiungi Invitati')"
              :url="'events/getemployees'"
              :debounceTime="2000"
              :clickFn="inviteUser"
              :canAdd="true"
              :attachedData="{ work: event.work }"
              :addFn="() => (manualInvite = true)"
            ></wg-search>
            <template v-else>
              <input
                class="anm22-calendar-input-text"
                type="email"
                v-model="inviteEmail"
                :placeholder="
                  $anm22.strLang(lang, 'E-mail', 'Indirizzo E-mail')
                "
              />
              <input
                type="button"
                class="action-button anm22-calendar-input-submit"
                @click="inviteExt"
                :value="$anm22.strLang(lang, 'Invite', 'Invita')"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <!-- Cancellazione evento - solo creatore -->
    <div
      v-if="event.creator === user.idWorldUser && event.type !== 6"
      class="wg-row"
      style="cursor: pointer; align-items: center; gap: 10px"
      @click="deleteEvent"
    >
      <img
        :src="$anm22.icons.getWorldIcon('deleteBin')"
        class="anm22-calendar-icon-inline"
      />
      <div class="anm22-calendar-field-inline anm22-calendar-field-inline-m">
        {{ $anm22.strLang(lang, "Delete Event", "Elimina Evento") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Event from "../events/types/Event.vue";
import Reminder from "../events/types/Reminder.vue";
import VircosDelivery from "../events/types/VircosDelivery.vue";
import WorldAddLink from "../../../../../world/spa/components/WorldAddLink.vue";
import WorldLinks from "../../../../../world/spa/components/WorldLinks.vue";
import EventFileUploader from "../events/EventFileUploader.vue";
import EventCover from "./EventCover.vue";
import EventMotorsport from './EventMotorsport.vue';

export default {
  components: {
    Event,
    Reminder,
    VircosDelivery,
    WorldAddLink,
    WorldLinks,
    EventFileUploader,
    EventCover,
    EventMotorsport,
  },
  props: {
    eventRef: Object,
    currentWork: [Number, String],
  },
  data() {
    return {
      loading: false,
      deleteDialog: false,
      deleteRoomDialog: false,
      showSaved: false,
      errors: [],
      event: { ...this.eventRef },
      // Gestione inviti
      manualInvite: false,
      inviteEmail: "",
      // Select progetti
      editingProject: false,
      projectOptions: [],
      resourcesOptions: [],
      projectSelect: null,
      resourceSelect: null,
      openLinkModal: false,
      editingResource: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    canEdit() {
      const invites = this.$store.getters["invites/getByEvent"](
        this.event.idWorldEvent
      );
      const admin = invites.find(
        (i) => i.user === this.user.idWorldUser && i.permission == 1
      );
      return !this.event.idWorldEvent || (admin && admin !== -1);
    },
    room() {
      return this.$store.getters["resources/get"](this.event.room);
    },
    // Types
    types() {
      var types = [
        {
          id: 1,
          label: this.$anm22.strLang(this.lang, "Event", "Evento"),
        },
        {
          id: 5,
          label: this.$anm22.strLang(this.lang, "Reminder", "Promemoria"),
        },
      ];
      if (this.event.work == 4432) {
        types.push({
          id: 7,
          label: this.$anm22.strLang(
            this.lang,
            "Public event",
            "Evento pubblico"
          ),
        });
      }
      return types;
    },
    // Gestione PROGETTO
    projectBorderColor() {
      switch (this.event.projectStatus) {
        case 1:
          return "#bdbdbd";
        case 2:
          return "#ffeb3b";
        case 3:
          return "#01d479";
        case 4:
          return "#00b0ff";
        case 5:
          return "#ff0000";
      }
    },
    // In futuro pensare ad una implementazione mediante libreria custom come permessi modifica Tasks
    canEditProjectLink() {
      return (
        this.currentWork !== 474 &&
        this.event.type !== 4 &&
        this.event.type !== 8 &&
        this.event.idWorldEvent
      );
    },
    // Gestione INVITI
    invites() {
      return this.$store.getters["invites/getByEvent"](this.event.idWorldEvent);
    },
    invitesWithUser() {
      return this.invites.map((i) => {
        return {
          invite: i,
          user: this.$store.getters["users/get"](i.user),
        };
      });
    },
    myInvite() {
      return this.invites.find(
        (invite) => invite.user === this.user.idWorldUser
      );
    },
  },
  methods: {
    getEventComponent() {
      switch (this.event.type) {
        case 5:
          return "Reminder";
        case 4:
        case 8:
          return "VircosDelivery";
        default:
          return "Event";
      }
    },
    setErrors(errors) {
      Object.keys(errors).forEach((keyError) => {
        if (errors[keyError] == null) {
          delete this.errors[keyError];
        } else {
          this.$set(this.errors, keyError, errors[keyError]);
        }
      });
    },
    searchProject(string) {
      const regexp = new RegExp(string, "i");
      return this.projectOptions
        .filter((p) => {
          const projectName = p.label;
          return -1 !== projectName.search(regexp);
        })
        .map((p) => {
          const pName = p.label;
          return {
            label: pName,
            id: p.id,
          };
        });
    },
    searchResources(string) {
      const regexp = new RegExp(string, "i");
      return this.resourcesOptions
        .filter((option) => {
          return -1 !== option.label.search(regexp);
        })
        .map((p) => {
          return {
            label: p.label,
            id: p.id,
          };
        });
    },
    projectName(project) {
      let projectName = "";
      projectName += project.projectId !== "" ? project.projectId : "";
      projectName += project.projectId !== "" ? "-" : "";
      projectName += project.name !== "" ? project.name : "";
      return projectName;
    },
    showLinkModal() {
      this.openLinkModal = !this.openLinkModal;
    },
    async saveLink(links) {
      try {
        const response = await this.$http.post(
          "events/links",
          {
            eventId: this.event.idWorldEvent,
            links: links,
          },
          {
            withCredentials: true,
          }
        );
        await this.$store.dispatch("events/update", {
          vlf: this.$vlf("events"),
          objs: [response.data.event],
        });
        this.event = { ...response.data.event };
      } catch (e) {
      } finally {
        this.openLinkModal = false;
      }
    },
    save(event) {
      if (Object.keys(this.errors).length > 0) {
        return;
      }
      //Salvo oggetto
      this.$http
        .post(
          "events/save",
          {
            event,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          return Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: [response.data.event],
            }),
            this.$store.dispatch("invites/update", {
              vlf: this.$vlf("invites"),
              objs: [response.data.invite],
            }),
            this.$store.dispatch("users/update", {
              vlf: this.$vlf("users"),
              objs: [response.data.user],
            }),
          ]).then(() => {
            if (event.idWorldEvent != null) {
              this.$emit("showEvent", response.data.event);
              this.event = response.data.event;
              this.showEventSaved();
            } else {
              this.$emit("showEvent", response.data.event);
              this.event = response.data.event;
            }
          });
        })
        .catch((error) => console.log(error));
    },
    updateEventProperty(propertyName, propertyValue, save) {
      this.event[propertyName] = propertyValue;
      if (save) {
        this.save(this.event);
      }
    },
    updateEventDataProperty(propertyName, propertyValue, save) {
      if (!this.event.jsonData) {
        this.event.jsonData = {};
      }
      this.event.jsonData[propertyName] = propertyValue;
      if (save) {
        this.save(this.event);
      }
    },
    showEventSaved() {
      this.showSaved = true;
      setTimeout(this.closeSaved, 5000);
    },
    closeSaved() {
      this.showSaved = false;
    },
    deleteEvent() {
      this.$http
        .post(
          "events/del",
          {
            event: this.event,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$store.dispatch("events/delete", {
            vlf: this.$vlf("events"),
            obj: this.event,
          });
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch((error) => console.log(error));
    },
    setRoom(resourceId) {
      this.$http
        .post(
          "events/set-room",
          {
            eventId: this.event.idWorldEvent,
            resourceId: resourceId,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: response.data.events,
            }),
            this.$store
              .dispatch("resources/update", {
                vlf: this.$vlf("resources"),
                objs: [response.data.resource],
              })
              .then(() => {
                const newEvent = response.data.events[0];
                this.editingResource = false;
                this.resourcesOptions = [];
                this.resourceSelect = null;
                this.event.room = newEvent.room;
              }),
          ]);
        })
        .catch((e) => console.log(e));
    },
    // Gestione PROGETTO
    setProjectLink(projectId) {
      this.$http
        .post(
          "events/setprojectlink",
          {
            eventId: this.event.idWorldEvent,
            projectId: projectId,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          Promise.all([
            this.$store
              .dispatch("events/update", {
                vlf: this.$vlf("events"),
                objs: response.data.events,
              })
              .then(() => {
                const newEvent = response.data.events[0];
                this.editingProject = false;
                this.projectOptions = [];
                this.projectSelect = null;
                // Aggiorno evento
                this.event.projectRef = newEvent.projectRef;
                this.event.projectStatus = newEvent.projectStatus;
                this.event.projectName = newEvent.projectName;
              }),
          ]);
        })
        .catch((e) => console.log(e));
    },
    editProjectRef() {
      this.$http
        .post(
          "events/getprojects",
          {
            workId: this.event.work,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.projectOptions = response.data.options;
          this.projectSelect = this.event.projectRef || "";
          this.editingProject = true;
        })
        .catch((e) => console.log(e));
    },
    editRoom() {
      this.$http
        .post(
          "events/get-resources",
          {
            workId: this.event.work,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.resourcesOptions = response.data.options;
          this.resourceSelect = this.event.room || "";
          this.editingResource = true;
        })
        .catch((e) => console.log(e));
    },
    stopEditResourceRef() {
      this.editingResource = false;
      this.resourcesOptions = [];
      this.resourceSelect = null;
    },
    stopEditProjectRef() {
      this.editingProject = false;
      this.projectOptions = [];
      this.projectSelect = null;
    },
    deleteRoomRef() {
      this.$http
        .post(
          "events/delete-room",
          {
            eventId: this.event.idWorldEvent,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          Promise.all([
            this.$store
              .dispatch("events/update", {
                vlf: this.$vlf("events"),
                objs: response.data.events,
              })
              .then(() => {
                this.editingResource = false;
                this.resourcesOptions = [];
                this.resourceSelect = null;
                this.deleteRoomDialog = false;
                // Aggiorno evento
                delete this.event.room;
              }),
          ]);
        })
        .catch((e) => console.log(e));
    },
    deleteProjectRef() {
      this.$http
        .post(
          "events/deleteprojectlink",
          {
            eventId: this.event.idWorldEvent,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          Promise.all([
            this.$store
              .dispatch("events/update", {
                vlf: this.$vlf("events"),
                objs: response.data.events,
              })
              .then(() => {
                this.editingProject = false;
                this.projectOptions = [];
                this.projectSelect = null;
                this.deleteDialog = false;
                // Aggiorno evento
                delete this.event.projectRef;
              }),
          ]);
        })
        .catch((e) => console.log(e));
    },
    // Gestione INVITI
    getStatusIcon(s) {
      switch (s) {
        case 1:
          return "tick";
        case 2:
          return "deleteRed";
        case 3:
          return "maybe";
      }
    },
    getStatusOptions(invite) {
      return [1, 2, 3].map((s) =>
        this.$anm22.tableClasses.inviteStatus().getById(s)
      );
    },
    inviteUser(id) {
      this.$http
        .post(
          "events/inviteuser",
          {
            id: id,
            idWorldEvent: this.event.idWorldEvent,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          //console.log(response.data);
          if (response.data.error) {
            this.errors.push(
              this.$anm22.strLang(
                this.lang,
                "User already invited",
                "Utente già aggiunto alla lista degli invitati"
              )
            );
          } else {
            this.$store.dispatch("invites/update", {
              vlf: this.$vlf("invites"),
              objs: response.data.invites,
            });
            this.$store.dispatch("users/update", {
              vlf: this.$vlf("users"),
              objs: response.data.users,
            });
          }
        })
        .catch((error) => {});
    },
    inviteExt() {
      this.$http
        .post(
          "events/invite",
          {
            idEvent: this.event.idWorldEvent,
            email: this.inviteEmail,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invites"),
            objs: [response.data.invites],
          });
        })
        .catch((error) => {});
      this.manualInvite = false;
    },
    delInvite(idWorldEventInvite) {
      //alert(idWorldEventInvite);
      this.$http
        .post(
          "events/delinvite",
          {
            idWorldEventInvite: idWorldEventInvite,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$store.dispatch("invites/delete", {
            vlf: this.$vlf("invites"),
            obj: response.data.invites,
          });
        })
        .catch((error) => {});
    },
    adminInvite(idWorldEventInvite) {
      this.$http
        .post(
          "events/admininvite",
          {
            idWorldEventInvite: idWorldEventInvite,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invites"),
            objs: [response.data.invites],
          });
        })
        .catch((error) => {});
    },
    eventStatus(idWorldEventInvite, status) {
      this.$http
        .post(
          "events/statusinvite",
          {
            idWorldEventInvite: idWorldEventInvite,
            status: status,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          //console.log(response.data);
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invites"),
            objs: [response.data.invites],
          });
        })
        .catch((error) => {});
    },
    delAdminInvite(idWorldEventInvite) {
      this.$http
        .post(
          "events/removeadmininvite",
          {
            idWorldEventInvite: idWorldEventInvite,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invites"),
            objs: [response.data.invites],
          });
        })
        .catch((error) => {});
    },
    async deleteEventLink(index) {
      let links = this.event.links;
      links.splice(index, 1);
      try {
        const response = await this.$http.post(
          "events/links",
          {
            eventId: this.event.idWorldEvent,
            links: links,
          },
          {
            withCredentials: true,
          }
        );
        this.$store.dispatch("events/update", {
          vlf: this.$vlf("events"),
          obj: response.data.event,
        });
      } catch (e) {}
    },
  },
  created() {
    if (this.event.idWorldEvent) {
      this.$http
        .post(
          "events/get-event-room",
          {
            eventId: this.event.idWorldEvent,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$store.dispatch("resources/update", {
            vlf: this.$vlf("resources"),
            objs: [response.data.resource],
          });
        })
        .catch((error) => {});
    }
  },
};
</script>

<style lang="scss" scoped>
.icon-div {
  border-radius: 30px;
  width: 50px;
  height: 50px;
  border: 1px solid #9999;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 5px;
  margin: 5px 10px;
  cursor: pointer;
  &:hover {
    border: none;
    background-color: #eee;
  }
}
.icon-div.desc-box {
  border: none;
  width: 40px;
  height: 40px;
  padding: 2px;
  background-color: #eee;
  &:hover {
    background-color: #ddd;
  }
}
.widgets-box {
  overflow-x: auto;
  max-width: 100%;
  white-space: nowrap;
  margin: 10px 0 0 0;
}
.widgets-box > div {
  display: inline-block;
  vertical-align: middle;
}
.type-select-elem {
  padding: 5px;
  margin-right: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
  &:hover {
    border: 1px solid #0aabf4;
  }
  &.selected {
    border: 2px solid #0aabf4;
  }
}
.invitation-title {
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 6px 0 12px 0;
  font-weight: 500;

  .label-ic {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
}
.invitation-container {
  margin: 15px 0;
  align-items: center;

  & > img {
    width: 24px;
    max-width: 24px;
    min-width: 24px;
    height: 24px;
    margin-right: 10px;
    border-radius: 50%;
    flex: 1;
  }

  .invitation-data {
    flex: 1;
  }

  .invitation-response-container {
    width: 100%;
    min-width: 100%;
    display: inline-block;
    padding: 6px 0 0 34px;

    .anm22-calendar-invite-status {
      border-radius: 6px;
      padding: 2px;
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;

      &::after {
        content: "";
      }
      &.selected {
        background-color: #eee;
      }
      &:hover {
        background-color: #eee;
      }
    }
  }
}
.new-invitation-container {
  .invite-add-ic {
    margin: 7px 10px 0 0;
    width: 24px;
    max-width: 24px;
    min-width: 24px;
    height: 24px;
    display: flex;
  }
  .new-invitation-data {
    flex: 1;
    .search-zone {
      width: auto;
    }
  }
}
.anm22-calendar-wrapper-calendar {
  margin: 0;
}
.project-link {
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 5px 5px 10px;
  border-radius: 4px;
  &:hover {
    background-color: #eee;
  }
}
.icon-button {
  margin-left: auto;
  margin-right: 10px;
  align-items: center;
  padding: 5px;
  border-radius: 4px;
  flex-wrap: nowrap;
  cursor: pointer;
  &:hover {
    background-color: #ddd;
  }
}
</style>
